import { supabase } from "@/integrations/supabase/client";

type TrackingAction = 'page_visit' | 'login' | 'download' | 'logout';

// Helper function to detect device type
const getDeviceType = (): string => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (/mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent)) {
    return 'mobile';
  }
  if (/tablet|ipad/.test(userAgent)) {
    return 'tablet';
  }
  return 'desktop';
};

// Helper function to get location (basic via IP geolocation)
const getLocation = async (): Promise<string | null> => {
  try {
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    return `${data.city}, ${data.country_name}`;
  } catch (error) {
    console.error('Failed to get location:', error);
    return null;
  }
};

export const trackUserAction = async (
  action: TrackingAction,
  details?: {
    page_path?: string;
    duration?: number;
    file_name?: string;
  }
) => {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.user?.email) return;

  const location = await getLocation();
  const deviceType = getDeviceType();
  const userAgent = navigator.userAgent;

  const { error } = await supabase.from('user_tracking').insert({
    user_email: session.user.email,
    action,
    location,
    device_type: deviceType,
    user_agent: userAgent,
    ...details
  });

  if (error) {
    console.error('Error tracking user action:', error);
  }
};

// Track page visits with duration
let pageVisitStartTime: number | null = null;

export const startPageVisit = () => {
  pageVisitStartTime = Date.now();
};

export const endPageVisit = async (pagePath: string) => {
  if (!pageVisitStartTime) return;
  
  const duration = Math.floor((Date.now() - pageVisitStartTime) / 1000); // Convert to seconds
  await trackUserAction('page_visit', {
    page_path: pagePath,
    duration
  });
  
  pageVisitStartTime = null;
};